import { createI18n } from "vue-i18n";

export const i18n = createI18n({
  locale: "en",
  missingWarn: false,
  fallbackFormat: true,
  messages: {
    en: {},
    de: {}
  }
});
